import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { Link, LinkProps } from 'react-router-dom';
import DocumentsImage from 'assets/images/data-room-empty-image.webp';

import './DashEmptyState.styles.scss';

type DashEmptyStateProps = {
  className?: string;
  title: string;
  imageSrc?: string;
  imageDescription?: string;
  link?: { label: string } & LinkProps;
};

const DashEmptyState: React.FC<DashEmptyStateProps> = (props) => {
  const { children, className, title, link, imageSrc, imageDescription } =
    props;

  const { label, ...linkProps } = link || { to: '' };

  const classes = classNames('dash-empty-state', className);

  return (
    <div className={classes}>
      <p>{title}</p>

      <ResolveImage
        src={imageSrc || DocumentsImage}
        asIllustration
        alt={`${title} empty state.`}
      />

      {imageDescription && (
        <p className="image-description">{imageDescription}</p>
      )}

      <div>
        {link && (
          <Link className="ncoded-button ncoded-button--outline" {...linkProps}>
            {label}
          </Link>
        )}
        {children}
      </div>
    </div>
  );
};

export default DashEmptyState;
